<template>
  <section>
      <!-- Company Page -->
    <div class="company_banner"></div>
    <!--<div class="row"><img src='/img/Image-company.png' class="img-responsive"></div>-->
    <div class="container page">
                  <about />
              <why />
              <div class="row"><div class="col-md-12">
          <div class="text-center">
            <p class="intro">
              To discuss how we can help, <a href="/contact" style="color: #c90e18;">contact us</a>, and we’ll be in touch with you shortly.
              </p>
              <p class="intro">
              Looking for career opportuninties, Look at our <a href="/Careers" style="color: #c90e18;">careers</a> section.
            </p>
            <br>
          </div>
  </div></div>
        </div>
  </section>
</template>
<script>
  import about from "./about"
  import why from "./testimonials"
  export default {
    components: {
      about,
      why
    }
  };

</script>
